var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "android-navbar-cancel.24c5e8c0.png","uri@2x": __webpack_public_path__ + "android-navbar-cancel.1f6e227e.png","uri@3x": __webpack_public_path__ + "android-navbar-cancel.a8fc7425.png",
    width: 15,
    height: 15
});